import React, { useEffect, useState } from 'react'
import ArrowUpTrayIcon from '../../../../components/elements/icons/ArrowUpTrayIcon';
import SearchField from '../../../../components/elements/SearchField';
import { debounce } from '../../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { clearCreatedAccount, fetchAccounts } from '../../../../store/actions/collegeAccountActions';
import ModalDialog from '../../../../components/layouts/ModalDialog';
import NewCollegeAccount from '../../../../components/partials/college-accounts/NewCollegeAccount';
import Loader from '../../../../components/elements/Loader';
import CollegeAccountCard from '../../../../components/partials/college-accounts/CollegeAccountCard';
import Pagination from '../../../../components/elements/Pagination';
import EmptyState from '../../../../components/elements/EmptyState';
import { SET_SUCCESS } from '../../../../store/types';

const CollegeAccounts = () => {
    const dispatch = useDispatch()
    const accountsSelector = useSelector(state => state.accounts)
    const [creatingAccount, setCreatingAccount] = useState(false);
    const [reload, setReload] = useState(0);
    const [activeFilters] = useState('');
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);

    useEffect(() => {
        dispatch(fetchAccounts(activeFilters, page, perPage))
        if(accountsSelector.createdAccount !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: "New college account created Successfully"
            })
            dispatch(clearCreatedAccount())
            setCreatingAccount(false)
        }
        return () => {
            
        };
    }, [accountsSelector.createdAccount, activeFilters, dispatch, page, perPage]);

    const searchAccounts = debounce((term) => {
        if(!term || term === '') setReload(reload + 1)
        dispatch(fetchAccounts(`name=${term}&applicationCode=${term}`, 0, 0))
    })
    return (
        <>
            <div className="w-full">
                <div className='py-3 mb-5'>
                    <div className="w-full mx-auto">
                        <div className='w-full flex items-center justify-between'>
                            <div className='w-2/3'>
                                <h4 className='font-medium text-lg mb-3 text-gray-400'>Vaatia College Accounts</h4>
                                <div className=''>
                                    <p className='text-gray-500 mt-1 text-sm'>
                                        Below is a list of payments to Vaatia College
                                    </p>
                                </div>
                            </div>
                            <button onClick={()=>{setCreatingAccount(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                Create an Account
                            </button>
                        </div>

                        <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
                            <div className='w-full'>
                                {/* <InvoicesFilters applyFilters={(filters)=>{
                                    console.log('filters => ', filters)
                                    setFilters(filters)
                                    }} 
                                /> */}
                            </div>
                            <div className='w-full flex flex-row-reverse gap-x-2'>
                                <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                                    <ArrowUpTrayIcon className={`w-5 h-5`} />
                                    Export Accounts
                                </button>
                                <div className='w-[350px]'>
                                <SearchField 
                                    placeholderText={`Search for account by name or account number`}
                                    showResultsDropDown={false}
                                    triggerSearch={(term)=>{searchAccounts(term)}}
                                    // performingSearch={invoicesSelector.loadingInvoices}
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                {accountsSelector.loadingAccounts 
                    ? 
                    <Loader /> 
                    :
                <>
                    {accountsSelector?.accounts?.accounts && accountsSelector?.accounts?.accounts?.length > 0 
                        ? 
                        <>
                            <div className='my-5 grid grid-cols-3 gap-8'>
                            {accountsSelector?.accounts?.accounts?.map((account, accountIndex) => (
                                <div key={accountIndex}>
                                    <CollegeAccountCard account={account} />
                                </div>
                            ))}
                            </div> 
                            <Pagination 
                            pagination={{
                                perPage, 
                                page,
                                totalItems: accountsSelector?.accounts?.total,
                            }} 
                            changePage={setPage} 
                            updatePerPage={setPerPage}
                            />
                        </>
                        : 
                        <EmptyState emptyStateText='No accounts have been created yet. Click on create new account above to create a new one'/>
                    }
                </>}
            </div>

            <ModalDialog
                shown={creatingAccount} 
                closeFunction={()=>{setCreatingAccount(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Create a new college account'
                maxWidthClass='max-w-lg'
                hideActions={true}
            >
                <NewCollegeAccount 
                    reload={()=>setReload(reload+1)}
                    closeFunction={()=>{setCreatingAccount(false)}} 
                />

            </ModalDialog>
        </>
    )
}

export default CollegeAccounts